// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-form-report-activity-card .mat-mdc-card {
  max-width: 80%;
  margin: 20px auto;
  padding: 0;
}
.fi-form-report-activity-card .mat-mdc-card .mat-mdc-card-title,
.fi-form-report-activity-card .mat-mdc-card .mat-mdc-card-content {
  padding: 10px 16px;
}
.fi-form-report-activity-card .mat-mdc-card .mat-mdc-card-title {
  border-radius: 4px 4px 0 0;
}
.fi-form-report-activity-card .mat-mdc-card .mat-mdc-card-content .fi-form-report-activity-paragraph {
  margin-bottom: 30px;
}`, "",{"version":3,"sources":["webpack://./Source/app/fi-form/fi-form-report/fi-form-report-activity-list/fi-form-report-activity-list.component.scss"],"names":[],"mappings":"AACI;EACI,cAAA;EACA,iBAAA;EACA,UAAA;AAAR;AAEQ;;EAEI,kBAAA;AAAZ;AAGQ;EACI,0BAAA;AADZ;AAKY;EACI,mBAAA;AAHhB","sourcesContent":[".fi-form-report-activity-card {\r\n    .mat-mdc-card {\r\n        max-width: 80%;\r\n        margin: 20px auto;\r\n        padding: 0;\r\n\r\n        .mat-mdc-card-title,\r\n        .mat-mdc-card-content {\r\n            padding: 10px 16px;\r\n        }\r\n\r\n        .mat-mdc-card-title {\r\n            border-radius: 4px 4px 0 0;\r\n        }\r\n\r\n        .mat-mdc-card-content {\r\n            .fi-form-report-activity-paragraph {\r\n                margin-bottom: 30px;\r\n            }\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
